import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { IMessage } from '@home/src/app/Interface/messages';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-single-comment',
  standalone: true,
  imports: [],
  providers: [DatePipe],
  templateUrl: './single-comment.component.html',
  styleUrl: './single-comment.component.css',
})
export class SingleCommentComponent {
  @Input({ required: true }) message!: IMessage;
  @Input() editEnable: boolean = false;
  @Input() showType: boolean = false;
  @Input() allDealers: any[] = [];

  @Output() deleteMessage = new EventEmitter<number>();

  @ViewChild('menu') menuRef!: ElementRef;

  showMenu: boolean = false;

  constructor(private datePipe: DatePipe) {}

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  getDealerName(code: string): string | undefined {
    return (
      this.allDealers.find((dealer) => dealer.emailAddress === code)
        ?.dealerName || this.message.emailAddress
    );
  }

  getOtherRecipients(): string {
    if (this.message.memberEmails.length < 1) return '';
    let names = '';
    this.message.memberEmails.forEach((code: string) => {
      names = names + ' | ' + this.getDealerName(code);
    });
    return names.substring(3);
  }

  getLocalDate(): string {
    const [datePart, timePart, modifier] = this.message.createdDate.split(' ');
    const [month, day, year] = datePart.split('/').map(Number);
    const [hoursStr, minutesStr] = timePart.split(':');
    let hours = Number(hoursStr);
    const minutes = Number(minutesStr);

    if (modifier === 'PM' && hours < 12) hours += 12;
    if (modifier === 'AM' && hours === 12) hours = 0;

    // Creates a date in local time (assumed to be UTC from server)
    const utcDate = new Date(Date.UTC(year, month - 1, day, hours, minutes));
    return this.datePipe.transform(utcDate, 'MM/dd/yyyy hh:mm a')!;
  }

  editComment() {
    // Edit is disabled for now as per the requirement
  }
  deleteComment(id: number) {
    this.deleteMessage.emit(id);
    this.showMenu = false;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (
      this.showMenu &&
      this.menuRef &&
      !this.menuRef.nativeElement.contains(event.target)
    ) {
      this.showMenu = false;
    }
  }
}
